import { FC, ReactNode, useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import { ContentLayout, WrapperLayout, WrapperSider } from "./styled";
import { NavBar } from "../ui";
import { useAdminMenuLayout } from "./hooks";
import { useSelector } from "react-redux";
import { selectCollapsed, selectUser, uiChangeCollapsedState } from "../../../redux";
import {
  readStoredUserRole,
  resolveSidebarMenuKey,
} from "../../utils/roles";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";

const { Content } = Layout;
interface Props {
  children: ReactNode;
  title: string;
  pageDescription: string;
}

export const AdminMenuLayout: FC<Props> = ({
  children,
  title,
  pageDescription,
}) => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);
  const collapsed = useSelector(selectCollapsed);
  const { items, items2, items3, items4, pathname } = useAdminMenuLayout();

  const role = user?.role ?? readStoredUserRole();

  const showMenu = useMemo(() => {
    switch (resolveSidebarMenuKey(role)) {
      case "seller":
        return items2;
      case "teacher":
        return items3;
      case "teacher_admin":
        return items4;
      case "admin":
        return items;
      default:
        return [];
    }
  }, [role, items, items2, items3, items4]);

  const expandedTeacherAdminSidebar = useRef(false);

  useEffect(() => {
    if (expandedTeacherAdminSidebar.current) return;
    if (resolveSidebarMenuKey(role) !== "teacher_admin") return;
    if (!collapsed) return;
    dispatch(uiChangeCollapsedState());
    expandedTeacherAdminSidebar.current = true;
  }, [role, collapsed, dispatch]);

  return (
    <WrapperLayout>
      <NavBar />
      <ContentLayout>
        <WrapperSider
          theme="light"
          width={240}
          collapsedWidth={80}
          collapsible
          collapsed={collapsed}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        >
          <div className="logo" />
          <Menu
            selectedKeys={[pathname]}
            defaultOpenKeys={["/gestion-academy"]}
            mode="inline"
            items={showMenu}
          />
        </WrapperSider>
        <Content>
          <div
            className="site-layout-background"
            style={{
              padding: 24,
              minHeight: 360,
              overflow: "auto",
            }}
          >
            <div style={{ marginBottom: 24 }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#072082",
                }}
              >
                {title}
              </h1>
              {pageDescription && (
                <p
                  style={{
                    margin: "8px 0 0 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  {pageDescription}
                </p>
              )}
            </div>
            {children}
          </div>
        </Content>
      </ContentLayout>
    </WrapperLayout>
  );
};
